import { Component } from '@angular/core';

@Component({
  selector: 'app-paiduserlanding',
  templateUrl: './paiduserlanding.component.html',
  styleUrl: './paiduserlanding.component.scss'
})
export class PaiduserlandingComponent {

}
